import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import {connect} from "react-redux";
import {openModalOtherSales} from "../../actions/ModalOtherSalesActions";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableList} from "../../actions/DynamicTableDataAction";
import TipDialog from "../../components/sale/TipDialog";
import QuestionDialog from "../../components/extras/QuestionDialog";
import DataService from "../../functions/DataService";
import {showToast} from "../../actions/ToastAction";
import localDB from "../../data/localDB";

class Tips extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            table_other_sales: {
                headers: ['Fecha', 'Valor', 'Acciones'],
                name: 'Propina',
                title: 'Propinas',
                has_actions: true,
                can_add: true,
                edit: localDB.get('rol_access').includes('manage_tips'),
                delete: localDB.get('rol_access').includes('manage_tips'),
                navigate: false,
                pagination: true,
                url: 'tips-openbox',
                values: ['id', 'date', 'amount'],
                id: 'table_tips',
                money_fields: ['amount'],
                datetime_fields: ['date'],
            }
        }
        this.tip_dialog = React.createRef();
        this.delete_dialog = React.createRef();
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.tip_dialog.current.handleToggleModal()
        }else if(response.event === 'edit'){
            this.tip_dialog.current.handleToggleModal(response.data)
        }else if(response.event === 'delete'){
            this.delete_dialog.current.open('', response.data.id)
        }
    };

    callbackSuccessDialog = () =>{
        this.props.dynamicTableList({'refresh': true})
    }

    delete = (id) => {
        DataService.delete(`tips/${id}`, (res) => {
            if (res.deleted) {
                this.props.showToast({message: 'Propina Borrada!', type: 'success'});
                this.props.dynamicTableList({'refresh': true})
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        })
    }

    render() {
        return (
            <Grid stackable>
                <Grid.Row columns={1}>
                    <Grid.Column>
                        <DynamicTable {...this.state.table_other_sales} callbackDynamicTable={this.callbackDynamicTable} />
                    </Grid.Column>
                </Grid.Row>
                <TipDialog ref={this.tip_dialog} callbackSuccess={this.callbackSuccessDialog}/>
                <QuestionDialog ref={this.delete_dialog} message="Borrar esta propina" callbackConfirm={this.delete}/>
            </Grid>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openModalOtherSales(modal){
            dispatch(openModalOtherSales(modal))
        },
        dynamicTableList(data){
            dispatch(dynamicTableList(data))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(withRouter(Tips));


// WEBPACK FOOTER //
// ./src/containers/sale/Tips.js